export default function ReviewIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Review Icon</title>
      <path
        d="M5.00017 2.70403C5.09631 2.70403 5.18853 2.66584 5.25651 2.59785C5.3245 2.52986 5.3627 2.43765 5.3627 2.3415V1.61644C5.3627 1.52029 5.3245 1.42808 5.25651 1.36009C5.18853 1.2921 5.09631 1.25391 5.00017 1.25391C4.90402 1.25391 4.81181 1.2921 4.74382 1.36009C4.67583 1.42808 4.63763 1.52029 4.63763 1.61644V2.3415C4.63763 2.43765 4.67583 2.52986 4.74382 2.59785C4.81181 2.66584 4.90402 2.70403 5.00017 2.70403Z"
        fill="#FFF136"
      />
      <path
        d="M4.63763 8.38398C4.63763 8.48013 4.67583 8.57234 4.74382 8.64033C4.81181 8.70832 4.90402 8.74651 5.00017 8.74651C5.09631 8.74651 5.18853 8.70832 5.25651 8.64033C5.3245 8.57234 5.3627 8.48013 5.3627 8.38398V7.65892C5.3627 7.56277 5.3245 7.47056 5.25651 7.40257C5.18853 7.33458 5.09631 7.29639 5.00017 7.29639C4.90402 7.29639 4.81181 7.33458 4.74382 7.40257C4.67583 7.47056 4.63763 7.56277 4.63763 7.65892V8.38398Z"
        fill="#FFF136"
      />
      <path
        d="M2.35126 7.64896C2.42028 7.71485 2.51203 7.75162 2.60745 7.75162C2.70287 7.75162 2.79462 7.71485 2.86364 7.64896L3.32285 7.18976C3.38688 7.12103 3.42175 7.03013 3.42009 6.93621C3.41843 6.84229 3.38038 6.75268 3.31396 6.68626C3.24754 6.61984 3.15793 6.58179 3.06401 6.58013C2.97009 6.57848 2.87919 6.61334 2.81047 6.67738L2.35126 7.13658C2.28337 7.20456 2.24524 7.2967 2.24524 7.39277C2.24524 7.48884 2.28337 7.58099 2.35126 7.64896Z"
        fill="#FFF136"
      />
      <path
        d="M1.61638 5.36227H2.34144C2.43759 5.36227 2.5298 5.32407 2.59779 5.25609C2.66577 5.1881 2.70397 5.09589 2.70397 4.99974C2.70397 4.90359 2.66577 4.81138 2.59779 4.74339C2.5298 4.6754 2.43759 4.63721 2.34144 4.63721H1.61638C1.52023 4.63721 1.42802 4.6754 1.36003 4.74339C1.29204 4.81138 1.25385 4.90359 1.25385 4.99974C1.25385 5.09589 1.29204 5.1881 1.36003 5.25609C1.42802 5.32407 1.52023 5.36227 1.61638 5.36227Z"
        fill="#FFF136"
      />
      <path
        d="M3.32248 3.32328C3.39037 3.2553 3.42851 3.16316 3.42851 3.06709C3.42851 2.97102 3.39037 2.87887 3.32248 2.8109L2.86328 2.35169C2.79455 2.28766 2.70366 2.25279 2.60974 2.25445C2.51582 2.25611 2.42621 2.29416 2.35978 2.36058C2.29336 2.427 2.25531 2.51661 2.25366 2.61053C2.252 2.70445 2.28686 2.79535 2.3509 2.86407L2.81011 3.32328C2.87912 3.38917 2.97087 3.42594 3.0663 3.42594C3.16172 3.42594 3.25347 3.38917 3.32248 3.32328Z"
        fill="#FFF136"
      />
      <path
        d="M7.41704 2.94577C7.61726 2.94577 7.77957 2.78345 7.77957 2.58323C7.77957 2.38301 7.61726 2.2207 7.41704 2.2207C7.21682 2.2207 7.0545 2.38301 7.0545 2.58323C7.0545 2.78345 7.21682 2.94577 7.41704 2.94577Z"
        fill="#FFF136"
      />
      <path
        d="M8.38359 5.36227C8.58381 5.36227 8.74612 5.19996 8.74612 4.99974C8.74612 4.79952 8.58381 4.63721 8.38359 4.63721C8.18337 4.63721 8.02106 4.79952 8.02106 4.99974C8.02106 5.19996 8.18337 5.36227 8.38359 5.36227Z"
        fill="#FFF136"
      />
      <path
        d="M7.41704 7.77975C7.61726 7.77975 7.77957 7.61744 7.77957 7.41722C7.77957 7.217 7.61726 7.05469 7.41704 7.05469C7.21682 7.05469 7.0545 7.217 7.0545 7.41722C7.0545 7.61744 7.21682 7.77975 7.41704 7.77975Z"
        fill="#FFF136"
      />
    </svg>
  );
}
